//@ts-nocheck
// Import AOS
// import AOS from "aos";
// import "aos/dist/aos.css";
// Import components
import SplitText from "../components/SplitText";
import { searchpubsbodegas } from '../components/searchpubsbodegas';
import "../../sass/pages/_pubsYbodegas.scss";

window.addEventListener("load", () => {
  AOS.init({ once: 'true'});
  searchpubsbodegas();
  setSplits();
  carruselPubs();
  carruselExper();
  formOptions();
});

const setSplits = () => {
  new SplitText(".sectionPubsBodega--info .text_24");
  new SplitText(".sectionVivirBBC--info .text_24 p");
  new SplitText(".pubs .sectionsQueEs--header--item2--text .text_24");
  new SplitText(".bodega .sectionsQueEs--header--item2--text .text_24");
};

const carruselPubs = () => {
  gsap.registerPlugin(ScrollTrigger);
  let boxPubs = document.querySelector(
    ".sectionsQueEs.pubs .sectionsQueEs--body"
  );
  let slides = boxPubs.querySelectorAll(
    ".sectionsQueEs--body--item2--slides picture"
  ) as any;

  if (slides.length >= 2) {
    let parallaxImagen = gsap.timeline({
      scrollTrigger: {
        trigger: boxPubs,
        start: "top top",
        end: `+=2000`,
        ease: "ease",
        scrub: 1,
        pin: true,
        pinSpacing: true,
        id: `videoImagen`,
      },
    });

    slides.forEach((item, index) => {
      if (index >= 1) {
        parallaxImagen.from(item, {
          x: innerWidth * 1.0,
        });
      }
    });
  }
};

const carruselExper = () => {
  gsap.registerPlugin(ScrollTrigger);
  let boxExper = document.querySelector(".sectionExpereienciaParati");
  let slides = boxExper.querySelectorAll(
    ".sectionExpereienciaParati--slides picture"
  ) as any;

  if (slides.length >= 2) {
    let parallaxImagen = gsap.timeline({
      scrollTrigger: {
        trigger: boxExper,
        start: "center center",
        end: `+=2000`,
        ease: "ease",
        scrub: 1,
        pin: true,
        pinSpacing: true,
        id: `videoImagen`,
      },
    });

    slides.forEach((item, index) => {
      if (index >= 1) {
        parallaxImagen.from(item, {
          x: innerWidth * 1.0,
        });
      }
    });
  }
};

const formOptions = () => {
  let options = document.querySelectorAll(
    ".pubsform .js-form-type-checkbox .option"
  ) as any;
  options.forEach((element) => {
    element.addEventListener("click", function () {
      let container = element.closest(".js-form-type-checkbox");
      container.classList.toggle("activeOption");
    });
  });

  let options2 = document.querySelectorAll(
    ".bodegaform .js-form-type-checkbox .option"
  ) as any;
  options2.forEach((element) => {
    element.addEventListener("click", function () {
      let container = element.closest(".js-form-type-checkbox");
      container.classList.toggle("activeOption");
    });
  });
};
